<template>
	<div class="home width">

		<el-row>
			<!-- 图片轮播 -->
			<el-col :span="16">
				<div class="swiper-container1 swiper-container">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item, index) in carousel_list" v-bind:key="index">
							<img width="100%" height="410px" :src="item.imgurl" alt />
						</div>
					</div>
					<!-- Add Pagination -->
					<div class="swiper-pagination"></div>
				</div>
			</el-col>
			<!-- 通知公告 -->
			<el-col :span="8">
				<div class="notice">
					<el-card class="box-card">
						<div slot="header" class="clearfix">
							<b>通知公告</b>
							<el-button @click.native="$router.replace('/dynamic/inform')" style="float: right; padding: 3px 0" type="text">更多</el-button>
						</div>
						<ul>
							<!-- <li>
								<el-row>
									<el-col @click.native="newsDetail(news[0])">
										<h3>广东省版权保护联合会微信公众号开通！</h3>
										<p>我会微信公众号已开通，可扫描下方二维码关注我会微信公众号已开通，可扫描下方二维码关注。。</p>
									</el-col>
								</el-row>
							</li> -->
							<li class="news_list" v-for="(item, index) in inform" :key="index" v-show="index < 7">
								<i class="el-icon-caret-right"></i>
								<span @click="newsDetail(item)">{{item.name}}</span>
							</li>
						</ul>
					</el-card>
					<!-- 其他 -->
					<el-row class="else">
						<el-col :span="24" @click.native="zzq">
							<img src="../../assets/icon-6.png" alt="">
							<span>作品著作权登记</span>
						</el-col>
						<el-col :span="24">
							<span>.</span>
						</el-col>

					</el-row>
				</div>
			</el-col>
		</el-row>

		<el-row :gutter="20">
			<!-- 本会动态 -->
			<el-col style=" margin: 20px 0;font-size: 14px;" :span="8">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<b>本会动态</b>
						<el-button @click.native="$router.replace('/dynamic/own_dynamic')" style="float: right; padding: 3px 0" type="text">更多</el-button>
					</div>
					<ul>
						<!-- <li class="title" @click="ownDetail(ownDynamic[0])">
							<h3>我会教育和科技专业委员会正式挂牌成立</h3>
							<p>2020年1月9日，我会副会长单位、教育和科技专业委员会主任单位——深圳市中鹏教育教育科技股份有限公司《凝心聚力，跃2020》年会在深圳举行。我会常务副会长陈冬云、副会长兼秘书长梁守坚、教育和科技专业委员会副主任张敬斌教授、教育和科技专业委员会副主任兼秘书长梁悦教授等，应邀出席盛会，和中鹏教育集团500多名员工以及各级领导和嘉宾一起，满怀喜悦、共聚深圳，回首2019，展望2020。</p>
						</li> -->
						<li class="dynamic" v-for="(item, index) in ownDynamic" v-show="index < 9" v-bind:key="index">
							<div>
								<i class="el-icon-caret-right"></i>
								<span @click="ownDetail(item)">{{item.name}}</span>
							</div>
							<p>{{item.createtime}}</p>
						</li>
					</ul>
				</el-card>
			</el-col>

			<!-- 行业动态 -->
			<el-col style=" margin: 20px 0;font-size: 14px;" :span="8">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<b>行业动态</b>
						<el-button @click.native="$router.replace('/dynamic/trade_dynamic')" style="float: right; padding: 3px 0" type="text">更多</el-button>
					</div>
					<ul>
						<!-- <li class="title" @click="tradeDetail(tradeDynamic[0])">
							<h3>2020年国家版权局公益海报发布</h3>
							<p>为贯彻落实党中央、国务院关于加强知识产权工作的决策部署，庆祝第20个世界知识产权日，做好2020年全国知识产权宣传周相关工作，国家版权局自2020年4月中旬起集中开展版权宣传活动，并以4月20日至4月27日为重点宣传时段。国家版权局围绕“强化版权治理，优化版权生态”主题，制作了4幅</p>
						</li> -->
						<li class="dynamic" v-for="(item, index) in tradeDynamic" v-show="index < 9"  v-bind:key="index">
							<div>
								<i class="el-icon-caret-right"></i>
								<span @click="tradeDetail(item)">{{item.name}}</span>
							</div>
							<p>{{item.createtime}}</p>
						</li>
					</ul>
				</el-card>
			</el-col>

			<!-- 政策法规 -->
			<el-col style="font-size: 14px;" :span="8">
				<div class="law_btn">
					<div :span="11" @click="$router.replace('/demo')">
						<img src="../../assets/icon-7.png" alt="">
						<span></span>
					</div>
					<div @click="$router.replace('/file_download')" :span="11">
						<img src="../../assets/icon-5.png" alt="">
						<span>资料下载</span>
					</div>
				</div>
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<b>法律法规</b>
						<el-button @click="$router.replace({path: '/policies/detail', query: { id: policies[0].id }})" style="float: right; padding: 3px 0" type="text">更多</el-button>
					</div>
					<ul v-if="policies.length > 0">
						<!-- <li class="title" @click="$router.replace({path: '/policies/detail', query: { id: policies[0].id }})">
							<h3>{{ policies[0].title }}</h3>
							<p>现公布《中华人民共和国著作权法实施条例》，自2002年9月15日起施行。</p>
						</li> -->
						<li class="law" v-for="(item, index) in policies" v-show="index < 7" :key="index" @click="$router.replace({path: '/policies/detail', query: { id: item.id }})">
							<!-- <i class="el-icon-caret-right"></i>
							<span @click="tradeDetail(item)">{{item.name}}</span> -->
							<div>
								<i class="el-icon-caret-right"></i>
								<span @click="tradeDetail(item)">{{item.title}}</span>
							</div>
							<p>2020-11-02</p>
						</li>
					</ul>
				</el-card>
			</el-col>

		</el-row>

		<!-- 会员风采 -->
		<div class="carousel">
			<div>
				<img src="../../assets/istyle_title.png" alt="">
				<p>会员风采</p>
			</div>
			<div>
				<ul>
					<li v-for="(item, index) in company_logo" v-bind:key="index">
						<a :href="item.url">
							<img width="150px" height="50px" :src="item.img" alt="">
						</a>
					</li>
				</ul>
			</div>
			
		</div>

		<div id="banner" v-show="banner">
			<img @click="$router.replace('/mahatma')" width="140px" src="../../assets/cf186d1c3e9b3a89202274ff933ff8a.png" alt="">
			<img @click="banner = false" src="../../assets/icon-10.png" alt="">
		</div>

		<div id="code" v-show="code">
			<img width="130px" src="../../assets/1595300177.jpg" alt="">
			<img @click="code = false" src="../../assets/icon-10.png" alt="">
		</div>

	</div>
</template>

<script>
	import Swiper from "swiper/js/swiper";
	import "swiper/css/swiper.min.css";

	export default {
		data() {
			return {
				carousel_list: [],
				company_logo: [
					{
						id: 1,
						img: require("../../assets/1594892373.png"),
						url: 'http://www.cnscee.com/'
					},
					{
						id: 3,
						img: require("../../assets/1594892393.jpg"),
						url: 'http://www.jxcchina.com/'
					},
					{	
						id: 2,
						img: require("../../assets/1594892414.jpg"),
						url: 'https://www.gstarcad.com/'
					},
					{
						id: 4,
						img: require("../../assets/1594892449.jpg"),
						url: 'https://www.zwcad.com/'
					},
					{
						id: 5,
						img: require("../../assets/1594892448.png"),
						url: 'http://www.gdpg.com.cn/    '
					},


					{
						id: 1,
						img: require("../../assets/1594892373.png"),
						url: 'http://www.cnscee.com/'
					},
					{
						id: 3,
						img: require("../../assets/1594892393.jpg"),
						url: 'http://www.jxcchina.com/'
					},
					{	
						id: 2,
						img: require("../../assets/1594892414.jpg"),
						url: 'https://www.gstarcad.com/'
					},
					{
						id: 4,
						img: require("../../assets/1594892449.jpg"),
						url: 'https://www.zwcad.com/'
					},
					{
						id: 5,
						img: require("../../assets/1594892448.png"),
						url: 'http://www.gdpg.com.cn/    '
					},
				],
				inform: [],
				ownDynamic: [],
				tradeDynamic: [],
				policies: [],
				banner: true,
				code: true,
				timer: null,
				calleft: 0
			}
		},

		mounted() {
			this.$router.scrollBehavior

			// 获取轮播图
			this.getCarousel()
			// 获取通知公告
			this.getNotice()
			// 获取本会动态
			this.getOurDynamic()
			// 获取行业动态
			this.getTradeDynamic()
			// 获取政策法规
			this.getPolicies()
		},
		methods: {
			login() {
				window.location.href = 'http://www.gd-copyright.cn/gdcrsp/'
			},
			// 获取轮播图
			getCarousel() {
				this.$axios({
					url: 'http://wine.gzcc315.com/getCpImg',
					method: 'post',
					data: this.$qs.stringify({
						pageNum: 1,
						type: 1
					}) 
				}).then(res => {
					this.carousel_list = res.data.data.list;
					setTimeout( () => {
						const swiper = new Swiper(".swiper-container1", {
							autoplay: {
								delay: 2500,
								disableOnInteraction: false,
							},
							loop: true,
							pagination: {
								el: ".swiper-pagination",
								clickable: true,
								dynamicBullets: true
							},
							autoplayDisableOnInteraction: false,
						});
					}, 1000)
				})
			},
			// 获取通知公告
			getNotice() {
				this.$axios({
					url: 'http://wine.gzcc315.com/getCpNewsList',
					method: 'post',
					data: this.$qs.stringify({
						pageNum: 1,
						type: 3
					})
				}).then( res => {
					this.inform = res.data.data.list;
				})
			},
			// 获取本会动态
			getOurDynamic() {
				this.$axios({
					url: 'http://wine.gzcc315.com/getCpNewsList',
					method: 'post',
					data: this.$qs.stringify({
						pageNum: 1,
						type: 1
					})
				}).then( res => {
					var data = res.data.data.list;
					for(var i in data) {
						var date = data[i].createtime.split(' ')
						data[i].createtime = date[0]
					}
					this.ownDynamic = data;
				})
			},
			// 获取行业动态
			getTradeDynamic() {
				this.$axios({
					url: 'http://wine.gzcc315.com/getCpNewsList',
					method: 'post',
					data: this.$qs.stringify({
						pageNum: 1,
						type: 2
					})
				}).then( res => {
					var data = res.data.data.list;
					for(var i in data) {
						var date = data[i].createtime.split(' ')
						data[i].createtime = date[0]
					}
					this.tradeDynamic = data;
				})
			},
			// 获取政策法规
			getPolicies() {
				this.$axios({
					url: 'http://copyright.gzcc315.com/policiesList',
					method: 'get',
				}).then( res => {
					console.log(res)
					// var data = res.data.data.list;
					this.policies = res.data;
				})
			},
			// 作品著作权登记
			zzq() {
				window.location.href = 'http://www.gd-copyright.cn'
			},
			// 本会动态详情页
			ownDetail(data) {
				sessionStorage.setItem('dynamic_content', JSON.stringify(data))
				this.$router.replace('/dynamic/dynamic_content');
			},
			// 行业动态详情
			tradeDetail(data) {
				sessionStorage.setItem('dynamic_content', JSON.stringify(data))
				this.$router.replace('/dynamic/dynamic_content');
			},
			// 通知公告详情
			newsDetail(data) {
				sessionStorage.setItem('dynamic_content', JSON.stringify(data))
				this.$router.replace('/dynamic/dynamic_content');
			}

		}
	}
</script>
<style>
	.el-card__header,
	.el-card__body {
		padding: 10px 20px !important;
	}

	.el-menu--horizontal .el-submenu i {
		color: #fff;
	}
</style>
<style scoped>
	.home {
		margin-top: 10px;
	}

	#banner {
		position: fixed;
		top: 60%;
		left: 1%;
		z-index: 999;
	}

	#banner img:last-child {
		position: absolute;
		bottom: -10px;
		right: -15px;
	}

	#banner:hover {
		cursor: pointer;
	}

	#code {
		position: fixed;
		top: 65%;
		right: 1%;
		z-index: 999;
	}

	#code img:last-child {
		position: absolute;
		bottom: -10px;
		left: -15px;
	}

	.swiper-container-free-mode>.swiper-wrapper {
		-webkit-transition-timing-function: linear;
		/*之前是ease-out*/
		-moz-transition-timing-function: linear;
		-ms-transition-timing-function: linear;
		-o-transition-timing-function: linear;
		transition-timing-function: linear;
		margin: 0 auto;
	}

	.swiper-container1 {
		width: 800px;
		margin: 0;
	}

	.swiper-container1 img {
		border-radius: 5px;
	}
	
	.swiper-container2 img:hover {
		cursor: pointer;
	}

	.notice ul li {
		border-bottom: 1px dotted #ccc;
		font-size: 13px;
		color: gray;
		padding-bottom: 10px;
	}

	.notice ul li.news_list {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding: 10px 0;
	}

	.notice ul li .el-row .el-col:last-child h3 {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 16px;
		margin-bottom: 7px;
		color: #303133;
	}

	.notice ul li .el-row .el-col:last-child h3:hover {
		cursor: pointer;
		color: #016fb8;
	}

	.notice ul li .el-row .el-col:last-child p {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		color: gray;
		font-size: 13px;
		line-height: 150%;
	}

	.notice ul li:last-child {
		border: none;
	}

	.notice ul li i {
		margin-right: 5px;
	}

	.notice ul li span:hover {
		cursor: pointer;
		color: #016fb8;
	}

	.else .el-col {
		color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 15px 0;
		border-radius: 5px;
		margin-top: 10px;
	}

	.else .el-col:hover {
		cursor: pointer;
	}

	.else .el-col:first-child {
		background: #409EFF;
	}

	.else .el-col:nth-child(2) {
		background: #F56C6C;
	}

	.else .el-col img {
		width: 24px;
		margin-right: 5px;
		vertical-align: middle;
	}

	.else .el-col span {
		vertical-align: middle;
	}

	.industry {
		margin: 20px 0;
		font-size: 14px;
	}

	.dynamic,
	.law {
		padding: 5px 0;
		display: flex;
		align-items: center;
		font-size: 13px;
		color: grey;
		box-sizing: border-box;
	}

	.dynamic, .law {
		justify-content: space-between;
	}

	.dynamic i,
	.law i {
		margin-right: 8px;
	}

	.dynamic div,
	.law div {
		display: flex;
		align-items: center;
	}

	.dynamic div span:nth-child(2),
	.law div span:nth-child(2) {
		width: 250px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.dynamic span:nth-child(2),
	.law span:nth-child(2) {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		border-bottom: 1px solid transparent;
	}

	.dynamic span:nth-child(2):hover,
	.law span:nth-child(2):hover {
		color: #016fb8;
		border-bottom: 1px solid #016fb8;
		cursor: pointer
	}

	.law_btn {
		display: flex;
		color: #fff;
		text-align: center;
		padding-bottom: 10px;
		box-sizing: border-box;
		margin-top: 25px;
	}

	.law_btn div {
		padding: 8px 0;
		border-radius: 5px;
	}

	.law_btn div:hover {
		cursor: pointer;
	}

	.law_btn div img {
		width: 24px;
		vertical-align: middle;
	}

	.law_btn div span {
		vertical-align: middle;
	}

	.law_btn div:first-child {
		width: 50%;
		background: #67C23A;
		margin-right: 12px;

	}

	.law_btn div:last-child {
		width: 50%;
		background: #E6A23C;
	}

	.title {
		padding-bottom: 10px;
		border-bottom: 1px dotted #ddd;
	}


	.title h3 {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-bottom: 5px;
		color: #303133;
	}

	.title h3:hover {
		color: #016fb8;
		cursor: pointer;
	}

	.title p {
		font-size: 12px;
		color: gray;
	}

	.title p:last-child {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		margin-top: 5px;
	}

	.clearfix b {
		border-left: 5px solid #016fb8;
		padding-left: 10px;
	}

	.carousel {
		display: flex;
		align-items: center;
		margin-top: 20px;
	}

	.carousel div:first-child {
		margin-right: 40px;
	}

	.carousel p {
		font-weight: bold;
		color: #016fb8;
		text-align: center;
	}

	.carousel div:last-child {
		width: 1000px;
		/* height: 80px;
		line-height: 80px; */
		overflow: hidden;
	}
	.carousel div:last-child ul {
		width: 3000px;
		animation: moves 10s linear infinite;
	}
	.carousel div:last-child ul:hover {
		animation-play-state:paused;
		cursor: pointer;
	}
	.carousel div:last-child ul li {
		width: 300px;
		padding: 20px 0;
		background: #fff;
		text-align: center;
		float: left;
	}
	.carousel div:last-child ul li img {
		display: inline-block;
	}

	@keyframes moves{
		0%{
			transform: translateX(0px);
		}
		100%{
			transform: translateX(-1500px);
		}
	}	
</style>
